<!-- Modal -->
<!--suppress AngularUndefinedBinding -->
<div class="modal fade" #modalElm tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'Opening new sub-accounts' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body">
        <p class="modal-text text-warning" translate>Note: The mobile number must be under the ownership of the identity holder.</p>
        <p class="modal-text" translate>Please type the number of sub-accounts to add:</p>
        <form [formGroup]="form" [hidden]="showOtp">
          <div class="form-group mb-3">
            <label for="subAccountCount" translate>No of sub-accounts</label>
            <div class="input-group">
              <input id="subAccountCount" [ngClass]="{ 'is-invalid': submitted && f.subAccountCount.errors }" type="number" class="form-control" formControlName="subAccountCount" name="subAccountCount" [placeholder]="'No of sub-accounts' | translate" aria-label="No of sub-accounts">
              <div class="input-group-append"><span class="input-group-text" id="basic-addon2" translate>Sub Account</span></div>
            </div>
            <small class="form-text text-danger" translate *ngIf="submitted && f.subAccountCount.errors?.required">Required field</small>
            <small class="form-text text-danger" translate *ngIf="submitted && f.subAccountCount.errors?.pattern">Invalid value</small>
          </div>
          <div class="form-group">
            <label for="justification" translate>Justification</label>
            <textarea id="justification" [ngClass]="{ 'is-invalid': submitted && f.justification.errors }" class="form-control" formControlName="justification" name="justification" rows="3"></textarea>
            <small class="form-text text-danger" translate *ngIf="submitted && f.justification.errors?.required">Required field</small>
          </div>
        </form>
        <form [formGroup]="otpForm" [hidden]="!showOtp">
          <div class="form-group mb-3">
            <label for="otp" translate>Absher OTP</label>
            <div class="input-group">
              <input id="otp" [ngClass]="{ 'is-invalid': submitted && of.otp.errors }" type="number" class="form-control" formControlName="otp" name="otp" [placeholder]="'Absher OTP' | translate" aria-label="Absher OTP">
              <div class="input-group-append"><span class="input-group-text" id="basic-addon2" translate>Absher OTP</span></div>
            </div>
            <small class="form-text text-danger" translate *ngIf="submitted && of.otp.errors?.required">Required field</small>
            <small class="form-text text-danger" translate *ngIf="submitted && of.otp.errors?.pattern">Invalid value</small>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>{{'Close' | translate}}</button>
        <button type="button" [hidden]="showOtp" (click)="addSubAccounts()" class="btn btn-primary" *ngIf="!loading" translate>Next</button>
        <button type="button" [hidden]="!showOtp" (click)="confirmOtp()" class="btn btn-primary" *ngIf="!loading" translate>Next</button>
        <button type="button" class="btn btn-primary" *ngIf="loading" translate>
          <div class="mx-auto spinner-grow text-dark align-self-center loader-lg"></div>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" #infoModal tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{modalTitle}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{modalMsg}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" translate>Close</button>
      </div>
    </div>
  </div>
</div>
